import React, { useEffect, useState } from 'react';
import './SildeBundleSort.scss';
import Button from '../../ui_elements/ButtonBundle/Button';
import * as constants from '../../../constants';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Translation from 'services/translation.service';

function Slide(props) {
  const [sortType, setSortType] = useState('asc');
  const [active, setActive] = useState(props.activeSlide);

  useEffect(() => {
    setActive(props.activeSlide);
  }, [props]);
  const handleButtonSort = () => {
    if (sortType === 'asc') {
      props.dispatch({
        type: constants.BUNDLE_ASCENDING,
        attrName: props.slide.name?.toLowerCase(),
      });
      setSortType('desc');
    } else {
      props.dispatch({
        type: constants.BUNDLE_DESCENDING,
        attrName: props.slide.name?.toLowerCase(),
      });
      setSortType('asc');
    }
  };
  return (
    // ${
    //   activeButtonSort === button.id ? 'active' : null
    // }
    <div
    // className="slide"
    // style={{
    //   width: props.data.slide_width + 'px',
    // }}
    >
      <div className="slider-sort-bundle-wrapper">
        <Button
          className={`btn-gray ${
            props?.slide?.name === active?.name ? 'active' : null
          }
            
            `}
          action={() => {
            handleButtonSort(props.slide);
            props.action(props.slide);
          }}
        >
          <span className="btn-sort-container">
            {active?.name === props?.slide?.name && (
              <span className="arrow-container">
                <span
                  className={`arrow-up-sort ${
                    sortType !== 'asc' ? 'active' : ''
                  }`}
                >
                  <KeyboardArrowUpIcon />
                </span>
                <span
                  className={`arrow-down-sort ${
                    sortType !== 'desc' ? 'active' : ''
                  }`}
                >
                  <KeyboardArrowDownIcon />
                </span>
              </span>
            )}
            {Translation.key(props?.slide?.localise_key)
              ? Translation.key(props?.slide?.localise_key)
              : props?.slide?.localise_key}
          </span>
        </Button>
      </div>
    </div>
  );
}

export default Slide;
